import React from 'react';
import './Plasticehandle.css';
import plastichandl from '../../../imgs/plastichandles.webp';

const Plasticehandle = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">Plastic Bottle Handles Injection Molding Production Line</h2>
                                <p className="Cavity-date">Oct. 27, 2022</p>               
                <div className="Ordinary">
                    <img src={plastichandl} alt="72 Cavity PET Preforms Machine" className="Cavity-image"/>
                </div>
                 <p className="Ordinary-text">Plastic handles can be understood as accessories attached to bottles or parts for holding or carrying. 
                    Mainly used to help people carry liquid plastic bottles, such as bottled drinking water,
                     cooking oil, sauces and beverages.</p>
                    

            </div>

        </div>
    );
};

export default Plasticehandle;
